import { axiosPost, axiosPut } from 'shared/api/axios'
import { AxiosError } from 'axios'
import { apiUrls } from 'consts'
import displayGenError from 'shared/utils/displayGenError'
import setFormValidationError from 'shared/utils/setFormValidationError'

interface submitFormProps {
  data: any
  setShowOverlay: Function
  id: string | undefined
  setError: Function
  extraData: any
}

const submitForm = async (props: submitFormProps) => {
  let response: any = false

  const formData = {
    ...props.data,
    role_api: props.data.role.value ?? null,
  }

  const catchFunc = (err: AxiosError) => {
    if (err.response!.status === 422) {
      const mappedAttributes: Map<string, string> = new Map()
      mappedAttributes.set('firstname', 'firstname')
      mappedAttributes.set('lastname', 'lastname')
      mappedAttributes.set('email', 'email')
      mappedAttributes.set('password_api', 'password_api')
      setFormValidationError(err, props.setError, mappedAttributes, 'firstname')
    } else {
      displayGenError({ setShowOverlay: props.setShowOverlay })
    }
  }

  if (props.id === undefined) {
    const roleIds: Array<number> = props.extraData.roles.map((r) => r.role_id)
    const customerIds: Array<number> = props.extraData.customers.map((c) => c.customer_id)
    const firstCustomerId : number | null | undefined = customerIds[0] ?? null
    response = await axiosPost(apiUrls.users, {
      ...formData,
      customer_id: firstCustomerId
    }, catchFunc).then(async (data) => {
      if (data?.status !== undefined && data.status === 201) {
        await Promise.all([
          ...customerIds.map((customerId) =>
            axiosPost(
              apiUrls.usersToCustomers,
              {
                customer_id: customerId,
                user_id: data.data.id,
              },
              catchFunc,
            )
          ),
          ...roleIds.map((roleId) =>
            axiosPost(
              apiUrls.usersToRoles,
              {
                role_id: roleId,
                user_id: data.data.id,
              },
              catchFunc,
            )
          ),
        ])
      }
      return data
    })
  } else {
    response = await axiosPut(apiUrls.users + '/' + props.id, formData, catchFunc)
  }
  return response
}

export default submitForm
